import TreeNode from "../../../models/TreeNode";

function constructTree(arr, getKey, getParentKey) {
  const itemDict = arr.reduce((a, i) => a.set(getKey(i), i), new Map());
  const allParentKeys = arr.map((x) => getParentKey(x));
  const allKeys = arr.map((x) => getKey(x));
  const allNodeKeys = [...allParentKeys, ...allKeys];
  const uniqueKeys = Array.from(new Set(allNodeKeys).values()).filter(Boolean);
  const nodes = uniqueKeys.map((x) => new TreeNode(x, null, itemDict.get(x)));
  const nodeMap = nodes.reduce((a, i) => a.set(i.id, i), new Map());

  arr
    .map((x) => ({ item: x, id: getKey(x), pId: getParentKey(x) }))
    .map((x) => ({ node: nodeMap.get(x.id), parentNode: nodeMap.get(x.pId) }))
    .filter((x) => x.node && x.parentNode)
    .map(({ parentNode, node }) => node.setParent(parentNode));

  return nodes.filter((x) => !x.parentId);
}

export default constructTree;
